import styled from "styled-components";

export const LottieAnimationDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: auto;
  margin-left: auto;
  padding-top: 80px;
`;
